/* Use Shopify's actual accelerated checkout. Never imitate a wallet button. */
(() => {
  'use strict';
  if (window.__enginoraExpress) return;
  window.__enginoraExpress = true;

  function supported() {
    try {
      return typeof window.ApplePaySession?.canMakePayments === 'function'
        && window.ApplePaySession.canMakePayments() === true;
    } catch (_error) {
      return false;
    }
  }

  function init(root = document) {
    const available = supported();
    root.querySelectorAll('[data-enginora-express]').forEach(container => {
      // Shopify remains responsible for wallet eligibility, the button's
      // branding and the payment flow. Keep Add to cart available regardless.
      container.hidden = !available;
    });
  }

  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pageshow', () => init());
})();
